import React from 'react';
import { compose, branch, renderComponent } from 'recompose';

export const nonOptimalStates = states =>
  compose(...states.map(s => branch(s.when, renderComponent(s.render))));

export function highlightText(text, higlight) {
  // https://stackoverflow.com/questions/29652862/highlight-text-using-reactjs
  // Split on higlight term and include term into parts, ignore case
  let parts = text.split(new RegExp(`(${higlight})`, 'gi'));
  return (
    <span>
      {' '}{parts.map((part, i) =>
        <span
          key={i}
          style={
            part.toLowerCase() === higlight.toLowerCase() ? { color: '#00CEE8' } : {}
          }>
          {part}
        </span>
      )}{' '}
    </span>
  );
}



// WEBPACK FOOTER //
// ./src/components/hocs/helpers.js